"use strict";

/**
 * @generated SignedSource<<71e2f7b76594355c66ab6579cddc9f76>>
 * @relayHash f923bcca0517101697998fbea5796a06
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d6579624e9a1425c3e19d9367f5bb7b9c2ae740e30b70b439782cb92ed830c18

const node = function () {
  var v0 = [{
      "kind": "Literal",
      "name": "first",
      "value": 1
    }, {
      "kind": "Literal",
      "name": "viewerManaged",
      "value": true
    }, {
      "kind": "Literal",
      "name": "visibility",
      "value": "EXISTS"
    }],
    v1 = {
      "alias": null,
      "args": null,
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }],
      "storageKey": null
    },
    v2 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    v3 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preferredSupplierId",
      "storageKey": null
    },
    v4 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": [],
      "kind": "Fragment",
      "metadata": null,
      "name": "useResolvedSupplierIdListQuery",
      "selections": [{
        "alias": null,
        "args": v0 /*: any*/,
        "concreteType": "SupplierResultConnection",
        "kind": "LinkedField",
        "name": "suppliers",
        "plural": false,
        "selections": [v1 /*: any*/, {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [{
            "args": null,
            "kind": "FragmentSpread",
            "name": "useSupplierMetaSupplier_Supplier"
          }],
          "storageKey": null
        }],
        "storageKey": "suppliers(first:1,viewerManaged:true,visibility:\"EXISTS\")"
      }, {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [v2 /*: any*/, {
          "kind": "ClientExtension",
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "ClientPreferences",
            "kind": "LinkedField",
            "name": "clientPreferences",
            "plural": false,
            "selections": [v3 /*: any*/],
            "storageKey": null
          }]
        }],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [],
      "kind": "Operation",
      "name": "useResolvedSupplierIdListQuery",
      "selections": [{
        "alias": null,
        "args": v0 /*: any*/,
        "concreteType": "SupplierResultConnection",
        "kind": "LinkedField",
        "name": "suppliers",
        "plural": false,
        "selections": [v1 /*: any*/, {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [{
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }, {
            "kind": "InlineFragment",
            "selections": [{
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dbId",
              "storageKey": null
            }, {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }],
            "type": "Supplier",
            "abstractKey": null
          }, {
            "kind": "InlineFragment",
            "selections": [v4 /*: any*/],
            "type": "Node",
            "abstractKey": "__isNode"
          }],
          "storageKey": null
        }],
        "storageKey": "suppliers(first:1,viewerManaged:true,visibility:\"EXISTS\")"
      }, {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [v2 /*: any*/, v4 /*: any*/, {
          "kind": "ClientExtension",
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "ClientPreferences",
            "kind": "LinkedField",
            "name": "clientPreferences",
            "plural": false,
            "selections": [v3 /*: any*/, v4 /*: any*/],
            "storageKey": null
          }]
        }],
        "storageKey": null
      }]
    },
    "params": {
      "id": "d6579624e9a1425c3e19d9367f5bb7b9c2ae740e30b70b439782cb92ed830c18",
      "metadata": {},
      "name": "useResolvedSupplierIdListQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "9cebaf1a3a0c7f61344c6ef5a18729ab";
export default node;